import { AiOutlineContacts, AiOutlineFieldTime, AiOutlineUserAdd } from "react-icons/ai";
import { MdGroups, MdOutlineSync } from "react-icons/md";

//Page / Card Title: Entra ID / Azure B2C User Provisioning
export const entraData = [
    {
      title: "Creating Microsoft Entra ID Employee Directory on WordPress",
      video: true,
      videoId: "I5ZlI9Vwudk",
      videoType: "youtube",
      icon: <AiOutlineUserAdd className='text-white fs-5' />
    },
    {
      title: "WP to Azure B2C User Sync: Integrate Moodle & Apps",
      video: true,
      videoId: "-5jXCwwwTTU",
      videoType: "youtube",
      icon: <MdOutlineSync className='text-white fs-5' />
    },
    {
      title: "Group/Role Mapping",
      video: false,
      videoId: "",
      videoType: "",
      icon: <MdGroups className='text-white fs-5' />
    },
    {
      title: "Profile Picture Sync",
      video: false,
      videoId: "",
      videoType: "",
      icon: <AiOutlineContacts className='text-white fs-5' />
    },
    {
      title: "Real-time Tracking",
      video: false,
      videoId: "",
      videoType: "",
      icon: <AiOutlineFieldTime className='text-white fs-5' />
    }
]